import React from 'react';
import GridLayout from './Layouts/GridLayoutSansCatalog';
import ListLayout from './Layouts/ListLayout';
import MobileLayout from './Layouts/MobileLayout';
import DetailLayout from './Layouts/DetailLayout';

const layouts = {
  grid: GridLayout,
  list: ListLayout,
  mobile: MobileLayout,
  detail: DetailLayout,
  default: GridLayout,
};

const LayoutContainerSansCatalog = ({ type, children }) => (
  layouts && layouts[type] !== undefined
    ? React.createElement(layouts[type], null, children)
    : React.createElement(layouts.default, null, children)
);

export default LayoutContainerSansCatalog;
